import type { Prompt } from "@1js/pl-card-components";
import React from "react";
import { HandoffFileSelectionMenu } from "../HandoffFileSelectionMenu/HandoffFileSelectionMenu.web";
import { useHandoff } from "./Handoff.web.hook";
import HandoffLoadingWindow from "./Loader/HandoffLoadingWindow";
import { Loader } from "./Loader/Loader.web";

type HandoffProps = {
  serviceHost: string;
  locale: string;
};

export type HandoffRef = {
  onTryInAppBadgeAction: (
    prompt: Prompt,
    product: string,
    tagRef: React.MutableRefObject<null>
  ) => void;
  onTryByCopyBadgeAction: (
    prompt: Prompt,
    product: string,
    tagRef: React.MutableRefObject<null>
  ) => void;
};

export const Handoff = React.forwardRef<HandoffRef, HandoffProps>(
  (props, ref) => {
    const { serviceHost, locale } = props;
    const {
      handoffFileSelectionMenuConfiguration,
      onHandoffFileSelectionMenuOpenChange,
      onLoaderCancel,
      loaderConfiguration,
      onLoaderCopy,
      onTryInAppBadgeAction,
      onTryByCopyBadgeAction,
      recentFiles,
      handoffLoadingWindow,
    } = useHandoff({ serviceHost, locale });

    React.useImperativeHandle(ref, () => ({
      onTryInAppBadgeAction: onTryInAppBadgeAction,
      onTryByCopyBadgeAction: onTryByCopyBadgeAction,
    }));

    return (
      <>
        <HandoffFileSelectionMenu
          isOpen={handoffFileSelectionMenuConfiguration.isOpen}
          product={handoffFileSelectionMenuConfiguration.product}
          onAction={handoffFileSelectionMenuConfiguration.onAction}
          onOpenChange={onHandoffFileSelectionMenuOpenChange}
          openRef={handoffFileSelectionMenuConfiguration.openRef}
          recentFiles={recentFiles}
        />
        {loaderConfiguration && (
          <Loader
            onCancel={onLoaderCancel}
            onCopy={onLoaderCopy}
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            destination={loaderConfiguration?.destination || ""}
            state={loaderConfiguration?.state || "loading"}
            prompt={loaderConfiguration?.prompt || undefined}
          />
        )}
        {handoffLoadingWindow && loaderConfiguration && (
          <HandoffLoadingWindow
            windowRef={handoffLoadingWindow}
            onCancel={onLoaderCancel}
            onCopy={onLoaderCopy}
            destination={loaderConfiguration.destination || ""}
            state={loaderConfiguration.state || "loading"}
            prompt={loaderConfiguration.prompt || undefined}
          />
        )}
      </>
    );
  }
);

Handoff.displayName = "Handoff";
